<template>
  <pt-read-people-table class="pt-read-people-table__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside" :isAddPageToRouter="isAddPageToRouter">
      <template slot="before">
        <slot name="before"/>
      </template>
      <slot/>
  </pt-read-people-table>
</template>

<script>
import PtReadPeopleTable from './index'
export default {
  name: 'pt-read-people-table__withData',
  components: {
    'pt-read-people-table': PtReadPeopleTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    isAddPageToRouter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$store.dispatch('getAllReadPersonnelList').then(res => {
        this.tableData = res
        if (next) {
          next(res)
        }
      }).catch(err => {
        this.$message.error(err || '获取解读师列表失败')
      })
    }
  },
  created () {
    this.getTableData()
  }
}
</script>
